

export default class PaginationResponseT<T>  {
	Count: number = 0;
	Items: Array<T> = null;
	constructor(obj?: Partial<PaginationResponseT<T>>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
